import { WModalButton, type WModalButtonProps } from "@/components/button/WToolButton.tsx";

export function AEditButton(props: Omit<WModalButtonProps, "label">) {
    return <WModalButton label="Edit" inTable icon="jp-icon-edit" {...props} />;
}
